import { render } from "./BlogAllxWhySmileMakeOver.vue?vue&type=template&id=36b33920"
import script from "./BlogAllxWhySmileMakeOver.vue?vue&type=script&lang=js"
export * from "./BlogAllxWhySmileMakeOver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__